// Content-type configuration shared across the app.

export const TYPES = {
  cases: { key: "cases", segment: "cases", label: "Cases", singular: "Case", kind: "entity",
    blurb: "Incidents and episodes across art crime, law, and controversy — theft, forgery, looting, fraud, restitution, censorship, and landmark legal battles." },
  people: { key: "people", segment: "people", label: "People", singular: "Person", kind: "person",
    blurb: "Artists, thieves, forgers, investigators, dealers, and the figures — culpable or not — who shaped these stories." },
  artworks: { key: "artworks", segment: "artworks", label: "Artworks", singular: "Artwork", kind: "entity",
    blurb: "Stolen, forged, recovered, and disputed objects at the heart of the cases." },
  museums: { key: "museums", segment: "museums", label: "Museums", singular: "Museum", kind: "entity",
    blurb: "Institutions that have been targets, custodians, and battlegrounds of cultural heritage." },
  news: { key: "news", segment: "news", label: "News", singular: "Story", kind: "article",
    blurb: "Current reporting on restitution, recoveries, trials, and the art market." },
  episodes: { key: "episodes", segment: "podcast", label: "Podcast", singular: "Episode", kind: "episode",
    blurb: "Long-form conversations and investigations from the COA studio." },
  essays: { key: "essays", segment: "essays", label: "Essays", singular: "Essay", kind: "article",
    blurb: "Criticism and reflection on the culture, ethics, and aesthetics of art crime." },
  mishaps: { key: "mishaps", segment: "museum-mishaps", label: "Museum Mishaps", singular: "Mishap", kind: "mishap",
    blurb: "A gallery of blunders — the tourists, toddlers, cleaners, and champagne corks that met priceless art and lost." },
};

export const NAV_ORDER = ["cases", "people", "artworks", "museums", "news", "episodes", "essays", "mishaps"];

export const SEGMENT_TO_TYPE = Object.fromEntries(
  Object.values(TYPES).map((t) => [t.segment, t.key])
);

export function linkTo(ctype, slug) {
  const t = TYPES[ctype];
  if (!t) return "/";
  return `/${t.segment}/${slug}`;
}

// Normalize display fields across heterogeneous content types.
export function getTitle(item) {
  return item?.title || item?.name || "Untitled";
}
export function getImage(item) {
  return resolveMedia(item?.hero_image || item?.image || "");
}
export function resolveMedia(url) {
  if (url && url.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
}
export function getBlurb(item) {
  return item?.summary || item?.dek || item?.description || item?.bio || "";
}
